import { Bar } from "vue-chartjs";

export default {
    extends: Bar,
    props: {
        // Object with a default value
        chartData: {
            type: Array,
        },
        title: {
            type: String,
            default: () => {
                return "";
            }
        }
    },
    watch: {
        chartData(newValue, OldValue) {
            if (newValue) {

                this.DrawChart()
            }
        }
    },
    data() {
        return {

            dataset: [],
            labels: [],
            xLabel: "",
            yLabel: ""
        };
    },
    mounted() {
        // window.addEventListener("resize", this.DrawChart());
        if (this.chartData) {
            this.DrawChart();
        }

    },

    methods: {
        processClusteredChart() {
            this.dataset = [];
            this.label = [];
            // var chartData = [{ "label": "feb", "value": 110, "color": "red", "groupBy": "fy2018", "isLineChart": 0, "ordinance": 2, "xlabel": "month", "ylabel": "revenue" },
            // { "label": "feb", "value": 210, "color": "green", "groupBy": "fy2019", "isLineChart": 0, "ordinance": 2, "xlabel": "month", "ylabel": "revenue" },
            // { "label": "feb", "value": 310, "color": "blue", "groupBy": "fy2020", "isLineChart": 0, "ordinance": 2, "xlabel": "month", "ylabel": "revenue" },
            // { "label": "jan", "value": 100, "color": "red", "groupBy": "fy2018", "isLineChart": 0, "ordinance": 1, "xlabel": "month", "ylabel": "revenue" },
            // { "label": "jan", "value": 200, "color": "green", "groupBy": "fy2019", "isLineChart": 0, "ordinance": 1, "xlabel": "month", "ylabel": "revenue" },
            // { "label": "jan", "value": 300, "color": "blue", "groupBy": "fy2020", "isLineChart": 0, "ordinance": 1, "xlabel": "month", "ylabel": "revenue" },
            // { "label": "march", "value": 120, "color": "red", "groupBy": "fy2018", "isLineChart": 0, "ordinance": 3, "xlabel": "month", "ylabel": "revenue" },
            // { "label": "march", "value": 220, "color": "green", "groupBy": "fy2019", "isLineChart": 0, "ordinance": 3, "xlabel": "month", "ylabel": "revenue" },
            // { "label": "march", "value": 320, "color": "blue", "groupBy": "fy2020", "isLineChart": 0, "ordinance": 3, "xlabel": "month", "ylabel": "revenue" }]




            if (this.chartData && this.chartData.length > 0) {
                this.yLabel = this.chartData[0].ylabel;
                this.xLabel = this.chartData[0].xlabel;


                // line chart Section
                var lineChartData = this.chartData.filter(x => x.isLineChart == true);
                if (lineChartData.length > 0) {
                    var lineChartObj = {
                        //Line Data
                        label: lineChartData[0].groupBy,
                        data: lineChartData.map(x => x.value),
                        borderColor: lineChartData[0].color,
                        fill: false,
                        lineTension: 0,
                        borderWidth: 2,
                        type: "line"
                    }

                    this.dataset.push(lineChartObj)
                }

                // 

                var barChartData = this.chartData.filter(x => x.isLineChart == false);
                this.labels = [...new Set(barChartData.map(x => x.label))];


                var barChartGrouping = [...new Set(barChartData.map(x => x.groupBy))];

                barChartGrouping.forEach((group) => {
                    {
                        var filteredGroup = barChartData.filter(x => x.groupBy == group);

                        var barChartObj = {
                            label: group,
                            backgroundColor: filteredGroup[0].color,
                            data: filteredGroup.map(x => x.value)
                        }


                        this.dataset.push(barChartObj);

                    }
                })
            }

        },
        DrawChart() {
            this.processClusteredChart();
            if (window.innerWidth < 600) {
                this.ChartForMobile();
            } else {
                this.InitChart();
            }
        },
        InitChart() {

            let context = this;
            this.renderChart(
                {
                    labels: context.labels,
                    datasets: context.dataset
                },
                {
                    maintainAspectRatio: false,
                    responsive: true,
                    height: 300,
                    title: {
                        display: true,
                        fontSize: 15,
                        text: context.title
                    },
                    legend: {
                        display: true,
                        labels: {
                            boxWidth: 10
                        }
                    },
                    scales: {
                        yAxes: [
                            {
                                scaleLabel: {
                                    display: true,
                                    labelString: context.yLabel
                                },
                                ticks: {
                                    suggestedMin: 0, // minimum will be 0, unless there is a lower value.
                                    // OR //
                                    beginAtZero: true // minimum value will be 0.
                                }
                            }
                        ],
                        xAxes: [
                            {
                                scaleLabel: {
                                    display: true,
                                    labelString: context.xLabel
                                }
                            }
                        ]
                    }
                }
            );
        },
        ChartForMobile() {
            let context = this;
            this.renderChart(
                {
                    labels: context.labels,
                    datasets: context.dataset
                },
                {
                    maintainAspectRatio: true,
                    responsive: true,
                    title: {
                        display: true,
                        fontSize: 15,
                        text: context.title
                    },
                    legend: {
                        display: true,
                        labels: {
                            boxWidth: 10,
                            fontSize: 14,
                            padding: 5
                        }
                        //position: "left"
                    },
                    scales: {
                        yAxes: [
                            {
                                scaleLabel: {
                                    display: false,
                                    labelString: context.yLabel
                                },
                                ticks: {
                                    suggestedMin: 0, // minimum will be 0, unless there is a lower value.
                                    // OR //
                                    beginAtZero: true, // minimum value will be 0.
                                    minRotation: 40,
                                    lineWidth: 0
                                }
                            }
                        ],
                        xAxes: [
                            {
                                scaleLabel: {
                                    display: false,
                                    labelString: context.xLabel
                                }
                            }
                        ]
                    }
                }
            );
        }
    },


}
